<div class="partners-container">
  <div class="header">
    <div class="header-content">
      <div>
        <h1>Partners</h1>
        <p>Manage and view all partner information</p>
      </div>
      <button class="create-btn" (click)="openCreateModal()">
        <i class="fas fa-plus"></i> Create Partner
      </button>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="error-message">
    <div class="error-content">
      <i class="fas fa-exclamation-triangle"></i>
      <span>{{ errorMessage }}</span>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading">
    <p>Loading partners...</p>
  </div>

  <!-- Table Container -->
  <div class="table-container" *ngIf="!loading && partners.length > 0">
    <!-- Desktop Table View -->
    <div class="table-wrapper">
      <table class="partners-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Contact Person</th>
            <th>Contact Number</th>
            <th>Email</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let partner of partners">
            <!-- Main row -->
            <tr class="partner-row" [class.expanded]="isRowExpanded(partner.id)">
              <td>{{ partner.name }}</td>
              <td>{{ partner.contactPerson }}</td>
              <td>{{ partner.contactNumber }}</td>
              <td>{{ partner.emailId || 'N/A' }}</td>
              <td>
                <div class="action-buttons">
                  <button 
                    class="expand-btn" 
                    (click)="toggleRow(partner.id)"
                    [class.expanded]="isRowExpanded(partner.id)" 
                    title="Expand to see details">
                    {{ isRowExpanded(partner.id) ? '▼' : '▶' }}
                  </button>
                  <button 
                    class="edit-btn"
                    (click)="openEditModal(partner); $event.stopPropagation()"
                    title="Edit Partner">
                    <i class="fas fa-edit"></i>
                  </button>
                </div>
              </td>
            </tr>
            
            <!-- Expanded row with full details -->
            <tr class="details-row" *ngIf="isRowExpanded(partner.id)">
              <td colspan="5">
                <div class="partner-details">
                  <div class="details-header">
                    <h4>Partner Details</h4>
                  </div>
                  <div class="details-grid">
                    <div class="detail-item">
                      <label>ID:</label>
                      <span>{{ partner.id }}</span>
                    </div>
                    <div class="detail-item">
                      <label>Name:</label>
                      <span>{{ partner.name }}</span>
                    </div>
                    <div class="detail-item full-width">
                      <label>Address:</label>
                      <span>{{ partner.address }}</span>
                    </div>
                    <div class="detail-item">
                      <label>Contact Person:</label>
                      <span>{{ partner.contactPerson }}</span>
                    </div>
                    <div class="detail-item">
                      <label>Contact Number:</label>
                      <span>{{ partner.contactNumber }}</span>
                    </div>
                    <div class="detail-item" *ngIf="partner.alternateContactNumber">
                      <label>Alternate Contact Number:</label>
                      <span>{{ partner.alternateContactNumber }}</span>
                    </div>
                    <div class="detail-item" *ngIf="partner.emailId">
                      <label>Email ID:</label>
                      <span>{{ partner.emailId }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <!-- No Data Message -->
  <div *ngIf="!loading && partners.length === 0" class="no-data">
    <p>No partners found.</p>
  </div>

  <!-- Create Partner Modal -->
  <div class="modal-overlay" *ngIf="showCreateModal" (click)="closeCreateModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Create Partner</h2>
        <button class="close-btn" (click)="closeCreateModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="createPartner()">
          <div class="form-group">
            <label for="name">Name *</label>
            <input type="text" id="name" [(ngModel)]="partnerForm.name" name="name" required class="form-input">
          </div>
          <div class="form-group">
            <label for="address">Address *</label>
            <textarea id="address" [(ngModel)]="partnerForm.address" name="address" required class="form-input"></textarea>
          </div>
          <div class="form-group">
            <label for="contactPerson">Contact Person *</label>
            <input type="text" id="contactPerson" [(ngModel)]="partnerForm.contactPerson" name="contactPerson" required class="form-input">
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="contactNumber">Contact Number *</label>
              <input type="text" id="contactNumber" [(ngModel)]="partnerForm.contactNumber" name="contactNumber" required class="form-input">
            </div>
            <div class="form-group">
              <label for="alternateContactNumber">Alternate Contact Number</label>
              <input type="text" id="alternateContactNumber" [(ngModel)]="partnerForm.alternateContactNumber" name="alternateContactNumber" class="form-input">
            </div>
          </div>
          <div class="form-group">
            <label for="emailId">Email ID</label>
            <input type="email" id="emailId" [(ngModel)]="partnerForm.emailId" name="emailId" class="form-input">
          </div>
          <div class="modal-footer">
            <button type="button" class="cancel-btn" (click)="closeCreateModal()">Cancel</button>
            <button type="submit" class="submit-btn" [disabled]="loading">Create</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Edit Partner Modal -->
  <div class="modal-overlay" *ngIf="showEditModal" (click)="closeEditModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Edit Partner</h2>
        <button class="close-btn" (click)="closeEditModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="updatePartner()">
          <div class="form-group">
            <label for="edit-name">Name *</label>
            <input type="text" id="edit-name" [(ngModel)]="partnerForm.name" name="edit-name" required class="form-input">
          </div>
          <div class="form-group">
            <label for="edit-address">Address *</label>
            <textarea id="edit-address" [(ngModel)]="partnerForm.address" name="edit-address" required class="form-input"></textarea>
          </div>
          <div class="form-group">
            <label for="edit-contactPerson">Contact Person *</label>
            <input type="text" id="edit-contactPerson" [(ngModel)]="partnerForm.contactPerson" name="edit-contactPerson" required class="form-input">
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="edit-contactNumber">Contact Number *</label>
              <input type="text" id="edit-contactNumber" [(ngModel)]="partnerForm.contactNumber" name="edit-contactNumber" required class="form-input">
            </div>
            <div class="form-group">
              <label for="edit-alternateContactNumber">Alternate Contact Number</label>
              <input type="text" id="edit-alternateContactNumber" [(ngModel)]="partnerForm.alternateContactNumber" name="edit-alternateContactNumber" class="form-input">
            </div>
          </div>
          <div class="form-group">
            <label for="edit-emailId">Email ID</label>
            <input type="email" id="edit-emailId" [(ngModel)]="partnerForm.emailId" name="edit-emailId" class="form-input">
          </div>
          <div class="modal-footer">
            <button type="button" class="cancel-btn" (click)="closeEditModal()">Cancel</button>
            <button type="submit" class="submit-btn" [disabled]="loading">Update</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

